import React from 'react'
import { Image } from '../Image'
import { RichText } from '../RichText'
import { Text } from '../Text'
import { IProps } from './index'
import { mq } from '../../utils'

export const CardWithIcon: React.FC<IProps> = ({ title, body, icon, cta }) => (
  <div className="card-with-icon">
    <div className="card-with-icon__icon">
      <Image {...icon} />
    </div>
    {title && (
      <div className="card-with-icon__title">
        <Text brand="default" size="heading-5">
          <RichText html={title} />
        </Text>
      </div>
    )}
    {body && (
      <div className="card-with-icon__body">
        <Text brand="default" size="body">
          {body}
        </Text>
      </div>
    )}
    {cta && <div className="card-with-icon__cta">{cta()}</div>}

    <style jsx>
      {`
        .card-with-icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;

          &__icon {
            max-width: 4rem;
            margin-bottom: 1.25rem;
          }

          &__title,
          &__body,
          &__cta {
            text-align: center;
          }

          &__title + &__body {
            margin-top: 0.25rem;
          }

          &__body {
            margin-bottom: auto;
          }

          &__body + &__cta {
            margin-top: 1.25rem;
          }

          &__cta {
            display: inline-block;
          }
        }

        @media (${mq.mobile}) {
          .card-with-icon {
            align-items: flex-start;
            &__icon {
              margin-bottom: 1.25rem;
            }

            &__title,
            &__body {
              text-align: left;
            }
          }
        }

        @media (${mq.tablet}) {
          .card-with-icon {
            align-items: start;

            &__icon {
              margin-bottom: 1.25rem;
            }

            &__title,
            &__body {
              text-align: left;
            }
          }
        }
      `}
    </style>
  </div>
)
